import React from 'react';
import { IHistoricoAjusteCircularizacao } from '../interfaces/ICircularizacao';

interface Props {
  historico: IHistoricoAjusteCircularizacao[];
  carregando: boolean;
  onFechar: () => void;
}

const LABEL_OPERACAO: Record<string, string> = {
  INCLUSAO: 'Inclusão',
  EXCLUSAO: 'Exclusão',
  ALTERACAO: 'Alteração',
  RESTAURACAO: 'Restauração',
};

const formatarDataHora = (iso: string) => new Date(iso).toLocaleString('pt-BR');

// Seção 5 — "Histórico de Ajustes da Seleção". Funciona só em memória nesta versão (sem
// gravação permanente em banco), conforme seção 15.
const HistoricoAjustesModal: React.FC<Props> = ({ historico, carregando, onFechar }) => (
  <div className='circ-modal-backdrop' onMouseDown={(e) => e.target === e.currentTarget && onFechar()}>
    <div className='circ-modal circ-modal-lg'>
      <div className='circ-modal-header'>
        <h4>Histórico de Ajustes da Seleção</h4>
        <button type='button' className='btn btn-sm btn-icon btn-light' aria-label='Fechar' onClick={onFechar}>
          <i className='bi bi-x-lg' />
        </button>
      </div>
      <div className='circ-modal-body'>
        {carregando && <div className='text-muted text-center py-5'>Carregando histórico...</div>}
        {!carregando && historico.length === 0 && (
          <div className='circ-empty-state'>
            <i className='bi bi-clock-history circ-empty-state-icon' />
            <div className='circ-empty-state-title'>Nenhum ajuste registrado</div>
            <div className='circ-empty-state-texto'>Inclusões, exclusões, alterações e restaurações aparecerão aqui.</div>
          </div>
        )}
        {!carregando &&
          historico.map((item) => (
            <div key={item.id} className='circ-historico-item'>
              <span className={`circ-historico-operacao circ-historico-operacao-${item.operacao}`}>
                {LABEL_OPERACAO[item.operacao]}
              </span>
              <div style={{ flex: 1 }}>
                <div>
                  <strong>{item.empresaNome}</strong> — {item.justificativa}
                </div>
                {item.informacaoOriginal && item.informacaoAtualizada && (
                  <div className='text-muted' style={{ fontSize: 11.5 }}>
                    De "{item.informacaoOriginal}" para "{item.informacaoAtualizada}"
                  </div>
                )}
                <div className='text-muted' style={{ fontSize: 11 }}>
                  {item.responsavel} · {formatarDataHora(item.dataHora)}
                </div>
              </div>
            </div>
          ))}
      </div>
      <div className='circ-modal-footer'>
        <button type='button' className='btn btn-sm btn-primary' onClick={onFechar}>
          Fechar
        </button>
      </div>
    </div>
  </div>
);

export default HistoricoAjustesModal;
